<app-circle-loader [loading]="isLoading">
  <app-card
    [actionButtons]="actionButtons"
    [buttonsWithLabels]="buttonsWithLabels"
    [buttons]="buttons"
    [dropdownOptions]="dropdownButtons"
    [informationBlocks]="informationBlocks"
    [informationLabels]="informationLabels"
    [showErrorHeader]="showErrorHeader"
    [showHeaderOverdue]="showHeaderOverdue"
    [showReopenRequestHeader]="showReopenRequestHeader"
    [showWarningHeader]="showWarningHeader"
    [title]="title">
    <ng-container cardCustomHeader>
      <ng-content select="[customHeader]"></ng-content>
    </ng-container>
    <ng-content></ng-content>
  </app-card>
</app-circle-loader>
